import { useState, useEffect, useCallback } from "react";
import Cookies from "js-cookie";
import { postApi } from "../../../../utils/api.ts";
import { API_GET_TIMESHEET_STATS } from "../../../../../config/Endpoints.js";
import { TimesheetStatsResponse } from "../types.ts";
export interface UseTimesheetStatsOptions {
  type?: 'MONTHLY' | 'WEEKLY' | 'DAILY';
}

export function useTimesheetStats(options: UseTimesheetStatsOptions = {}) {
  const { type = 'MONTHLY' } = options;
  const [data, setData] = useState<TimesheetStatsResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const accessToken = Cookies.get("accessToken");
   const employeedata = JSON.parse(localStorage.getItem("userData"));
   const id= employeedata.id ;

  const fetchStats = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      // If eeId is missing, we use 578 as per user request example, 
      // but in production it should always be available from cookies.
      const employeeId = id ;

      const response = await postApi<TimesheetStatsResponse>(
        API_GET_TIMESHEET_STATS,
        accessToken,
        {
          employeeId,
          type
        }
      );

      setData(response.data);
    } catch (err: any) {
      setError(err.message || "Failed to fetch timesheet statistics");
      console.error("Timesheet Stats Error:", err);
    } finally {
      setLoading(false);
    }
  }, [accessToken, id, type]);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return { data, loading, error, refetch: fetchStats };
}
